import { render, staticRenderFns } from "./ECommerceCollectDetail.vue?vue&type=template&id=7ac62361&scoped=true&"
import script from "./ECommerceCollectDetail.vue?vue&type=script&lang=js&"
export * from "./ECommerceCollectDetail.vue?vue&type=script&lang=js&"
import style0 from "./ECommerceCollectDetail.vue?vue&type=style&index=0&id=7ac62361&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac62361",
  null
  
)

export default component.exports